export const DEFAULT_QUERY_SIZES = {
  sm: 575.98,
  md: 767.98,
  lg: 991.98,
  xl: 1199.98,
};
